import { RequestError, } from './RequestError';
export class FetchApiError extends RequestError {
    static className = 'FetchApiError';
    constructor(props) {
        super(props);
    }
}
